var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_226)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0.1875L8.66534 3.21284L4.168 3.03816L3.55866 7.4995L0 10.2568L2.4 14.0648L1.44666 18.4648L5.73334 19.8395L7.832 23.8222L12 22.1195L16.168 23.8222L18.2667 19.8395L22.5533 18.4648L21.6 14.0648L24 10.2568L20.4413 7.4995L19.832 3.03816L15.3333 3.21284L12 0.1875ZM16.4093 7.89284L18.2573 9.8155L10.7573 17.0315L5.72266 11.9968L7.608 10.1115L10.7947 13.2968L16.4093 7.89284Z",
    fill: "white",
    fillOpacity: 0.66,
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 0.0640625
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertified);
export default __webpack_public_path__ + "static/media/certified.d9d5ce794c3af405f6c5a1fc971cd107.svg";
export { ForwardRef as ReactComponent };